import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface BrandImageProps {
  name: string;
  logo: string;
  onClick?: () => void;
}

export const BrandImage = ({ name, logo, onClick }: BrandImageProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement;
    target.style.display = "none";
    const parent = target.parentElement;
    if (parent) {
      const fallback = document.createElement("span");
      fallback.className = cn(textVariants.footnote, "text-center");
      fallback.textContent = name;
      parent.appendChild(fallback);
    }
  };

  return (
    <div
      className="w-[92px] h-[92px] flex items-center justify-center"
      onClick={onClick}
    >
      <img
        src={logo}
        alt={name}
        className="max-w-[80px] max-h-[55px] object-contain"
        onError={handleImageError}
      />
    </div>
  );
};
